import React from "react";
import {
    Row,
    Col,
    Card,
    CardHeader,
    CardTitle,
    Button,
    CardBody,
    FormGroup,
    Label,
    Input,
    Alert
} from "reactstrap"
import Async from 'react-select/async';

// Requests
import { getProjectsRequest } from "api/project";
import { getUnitRequest } from "api/units";
import { updateUnitRequest } from "api/units";
import { createUnitRequest } from "api/units";
import { getClientsRequest } from "api/client";
import { getProjectRequest } from "api/project";
import { getBrokersRequest, getBrokerRequest } from "api/broker";
import { getSellersRequest, getSellerRequest } from "api/seller";
// Helpers
import { formatUnitStatus } from "helpers/status";
import { calculateVATByPrice } from "helpers/pricing";
import { calculateTCP } from "helpers/pricing";
// Components
import CurrencyInput from "components/CurrencyInput/CurrencyInput";
// Constants
import { unitOrietantion, unitStatuses } from "../../constants";
// Contexts
import ProjectContext from "contexts/ProjectContext";
import { formatUnitOrietation } from "helpers/status";

class UnitForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            unit: {},
            filtersProjects: {},
            saving: false,
            error: null,
            projectModels: [],
            commissions: [],
            totalCommissionPercentage: 0,
            maxCommission: 7.5
        };
    }

    static contextType = ProjectContext;
    
    async componentDidMount() {
        this.previousContext = this.context

		const params = new URLSearchParams(this.props.location.search);
		const id = params.get('id');
        const { selectedProject } = this.context
    
        if(selectedProject) {
            this.handleDefaultProject(selectedProject)
        }

        if (id) {
			try {
				const unit = await getUnitRequest(id);
                let projectModels = [];


                if(unit.project) {
					unit.selectedProject = {
						label: `${unit.project.name}`,
						value: unit.project._id
					};

                    projectModels = unit.project.models;
                }

                if (unit.client) {
					unit.client = {
						label: `${unit.client.first_name} ${unit.client.last_name}`,
						value: unit.client._id
					};

                    projectModels = unit.project.models;
                }

                // Initialize commissions from unit data
                const commissions = await this.loadCommissionRecipientData(unit.commissions || []);
                const totalCommissionPercentage = commissions.reduce((sum, commission) => sum + (parseFloat(commission.percentage) || 0), 0);

                let selectIndex = unit.models.findIndex(x => x.name === unit.selectedModel.name)

				this.setState({ 
                    unit,
                    selectIndex,
                    projectModels,
                    commissions,
                    totalCommissionPercentage
                })
			} catch(err) {
				this.setState({
					error: err.message || 'There was an error fetching unit'
				});
			}
        }
    }

    async componentDidUpdate() {
        const { selectedProject } = this.context;
        
        if(this.previousContext.selectedProject !== selectedProject) {
            if(this.previousContext.selectedProject) {
                window.location.reload()
            }
            
            this.previousContext.selectedProject = selectedProject
            
            if(selectedProject) {
                this.handleDefaultProject(selectedProject)
            
            }

        }
    }

    handleDefaultProject = async (selectedProject) => {
        const project = await getProjectRequest(selectedProject)

        this.setState(prevState => ({
            unit: {
                ...prevState.unit,
                project: project,
                selectedProject: {
                    label: `${project.name}`,
                    value: project._id
                },
                // models: project.models,
            },
            projectModels: project.models,
            maxCommission: project.maxCommission
        }))
    }
    

    goTo = path => this.props.history.push(path);

    onChangeField = (e) => {
		const { target } = e;
		let { name, value } = target;
		this.setState(prevState => ({
			unit: {
				...prevState.unit,
				[name]: value,
			},
		}));
	}
    
    onChangeModelField = (e) => {
        const { selectedModel, status } = this.state.unit
        const { target } = e;
        let { name, value } = target;

        if (status === 'sold') {
            this.setState(prevState => ({
                unit: {
                    ...prevState.unit,
                    [name]: value,
                    selectedModel: {
                        ...selectedModel,
                        [name]: value,
                    }
                },
            }));
        } else {
            this.setState(prevState => ({
                unit: {
                    ...prevState.unit,
                    selectedModel: {
                        ...selectedModel,
                        [name]: value,
                    }
                },
            }));
        }

    }

    onSelectChange = (key) => (object) => {
        const { value } = object.target

        if (key === 'status') {
            this.setState(prevState => ({
                unit: {
                    ...prevState.unit,
                    [key]: value,
                },
                selectedStatus: value
            }));    
        } else {
            this.setState(prevState => ({
                unit: {
                    ...prevState.unit,
                    [key]: value,
                },
            }));
        }

	}

    onSpecialSelectChange = (key, index) => (object) => {
        const { models=[], project} = this.state.unit

        if(key === 'selectedProject') {
            this.setState(prevState => ({
                unit: {
                    ...prevState.unit,
                    [key]: object,
                    project: object.data,
                },
                projectModels: object.data.models,
            }));
        } else if (key === 'selectedModel') {
            let modelIndex = object.target.value

            this.setState(prevState => ({
                unit: {
                    ...prevState.unit,
                    selectedModel: models[modelIndex],
                    price: models[modelIndex].price,
                    vat: models[modelIndex].vat,
                    tcp: models[modelIndex].tcp,
                },
                selectIndex: modelIndex
            }))
        } else if (key === 'selectedModelType') {
            let projectModelIndex = object.target.value


            models[index].price = project?.models[projectModelIndex].price
            models[index].vat = project?.models[projectModelIndex].vat
            models[index].tcp = project?.models[projectModelIndex].tcp
            models[index].name = project?.models[projectModelIndex].name

            this.setState(prevState => ({
                unit: {
                    ...prevState.unit,
                    models
                },
            }))
        } else  {
            this.setState(prevState => ({
                unit: {
                    ...prevState.unit,
                    [key]: object,
                },
            }))
        }
    }

    onChangeCheckbox = (e, index) => {
        const { models} = this.state.unit

	    models[index].price = null
        models[index].vat = null
        models[index].tcp = null
        models[index].notAvailable = true

        
        this.setState(prevState => ({
            unit: {
                ...prevState.unit,
                models,
            }
        }))
    }
	

    loadProjects = async (search, callback) => {
		const { filtersProjects } = this.state;

		this.setState({
			filtersProjects: {
				...filtersProjects,
				search
			}
		})
		if(search) {
			const projectResponse = await getProjectsRequest(filtersProjects);
			const projects = projectResponse.projects.map(project => {
				return {
					data: project,
					label: `${project.name}`,
					value: project._id
				}
			})
			callback(projects);
		}
	}

    loadClients = async (search, callback) => {
		const { filtersClients } = this.state;
		this.setState({
			filtersClients: {
				...filtersClients,
				search
			}
		})
		if(search) {
			const clientResponse = await getClientsRequest(filtersClients);
			const clients = clientResponse.clients.map(client => {
				return {
					data: client,
					label: `${client.first_name} ${client.last_name}`,
					value: client._id
				}
			})
			callback(clients);
		}
	}

    loadBrokers = async (search, callback) => {
		if(search) {
			const brokerResponse = await getBrokersRequest({ search, limit: 50 });
			const brokers = brokerResponse.brokers.map(broker => {
				return {
					data: broker,
					label: broker.name,
					value: broker._id
				}
			})
			callback(brokers);
		}
	}

    loadSellers = async (search, callback) => {
		if(search) {
			const sellerResponse = await getSellersRequest({ search, limit: 50 });
			const sellers = sellerResponse.sellers.map(seller => {
				return {
					data: seller,
					label: `${seller.first_name} ${seller.last_name}`,
					value: seller._id
				}
			})
			callback(sellers);
		}
	}

    loadCommissionRecipientData = async (commissions) => {
        const enrichedCommissions = await Promise.all(
            commissions.map(async (commission) => {
                if (commission.recipientType && commission.recipientId) {
                    try {
                        if (commission.recipientType === 'broker') {
                            const broker = await getBrokerRequest(commission.recipientId);
                            if (broker) {
                                return {
                                    ...commission,
                                    recipientName: broker.name,
                                    recipientData: broker
                                };
                            }
                        } else if (commission.recipientType === 'seller') {
                            const seller = await getSellerRequest(commission.recipientId);
                            if (seller) {
                                return {
                                    ...commission,
                                    recipientName: `${seller.first_name} ${seller.last_name}`,
                                    recipientData: seller
                                };
                            }
                        }
                    } catch (error) {
                        console.error('Error loading recipient data:', error);
                    }
                }
                return commission;
            })
        );
        return enrichedCommissions;
    }

    addModels = () => {
		const { models=[] } = this.state.unit;
		this.setState((prevState) => ({
			unit: {
				...prevState.unit,
				models: [
					...models,
					{
						name: '',
						price: 0,
						vat: 0,
						tcp: 0
					}
				]
			}
		}))
	}

    handleModelChange = (event) => {
		const { name, value, index } = event.target;
		const { models } = this.state.unit;
		const updatedModel = [...models];

        if (name === 'price') {
            let vat = calculateVATByPrice(value)
            let tcp = calculateTCP(value, vat)

            updatedModel[index] = {
                ...updatedModel[index],
                [name]: value,
                vat,
                tcp
            }
        } else {
            updatedModel[index] = {
                ...updatedModel[index],
                [name]: value,
            }
        }
		this.setState((prevState) => ({
			unit: {
				...prevState.unit,
				models: updatedModel
			}
		}));
	}

    deleteModel = (modelIndex) => () => {
		const { models=[] } = this.state.unit;
		const updateModel = [...models];

		updateModel.splice(modelIndex, 1);
		this.setState((prevState) => ({
			unit: {
				...prevState.unit,
				models: updateModel
			}
		}));
	}

    addCommission = () => {
		const { commissions = [] } = this.state;
		this.setState((prevState) => ({
			commissions: [
				...commissions,
				{
					recipientType: '',
					recipientId: '',
					percentage: 0
				}
			]
		}))
	}

    deleteCommission = (commissionIndex) => () => {
		const { commissions = [] } = this.state;
		const updatedCommissions = [...commissions];

		updatedCommissions.splice(commissionIndex, 1);
		const totalCommissionPercentage = updatedCommissions.reduce((sum, commission) => sum + (commission.percentage || 0), 0);
		
		this.setState({
			commissions: updatedCommissions,
			totalCommissionPercentage
		});
	}

    handleCommissionChange = (event) => {
		const { name, value, index } = event.target;
		const { commissions } = this.state;
		const updatedCommissions = [...commissions];

		updatedCommissions[index] = {
			...updatedCommissions[index],
			[name]: value,
		};

		// Recalculate total percentage
		const totalCommissionPercentage = updatedCommissions.reduce((sum, commission) => sum + (parseFloat(commission.percentage) || 0), 0);

		this.setState({
			commissions: updatedCommissions,
			totalCommissionPercentage
		});
	}

    onCommissionSelectChange = (key, index) => (object) => {
		const { commissions } = this.state;
		const updatedCommissions = [...commissions];

		if (key === 'recipientId') {
			updatedCommissions[index] = {
				...updatedCommissions[index],
				[key]: object.value,
				recipientName: object.label,
				recipientData: object.data
			};
		} else {
			updatedCommissions[index] = {
				...updatedCommissions[index],
				[key]: object.target.value,
				// Reset recipientId when recipientType changes
				recipientId: '',
				recipientName: '',
				recipientData: null
			};
		}

		this.setState({
			commissions: updatedCommissions
		});
	}



    save = async () => {
		this.setState({
			saving: true
		})

		const { unit, commissions, totalCommissionPercentage, maxCommission } = this.state;
		const { _id } = unit;

		// Validate total commission percentage
		if (totalCommissionPercentage > maxCommission) {
			this.setState({
				error: `Total commission percentage cannot exceed ${maxCommission}%`,
				saving: false
			});
			return;
		}

		// Prepare unit data with commissions
		const unitData = {
			...unit,
			commissions: commissions.filter(commission => 
				commission.recipientType && commission.recipientId && commission.percentage > 0
			)
		};

		try {
	        if (_id) {
				await updateUnitRequest(unitData);
			} else {
				await createUnitRequest(unitData);
			}
			this.setState({
				saving: false
			})
			this.goTo('/units');
		} catch (err) {
			this.setState({
				error: err.message || 'There was an error saving unit',
				saving: false
			})
		}
	}

    render() {
        const {
            unit,
            saving,
            error,
            projectModels,
            selectedStatus,
            selectIndex,
            commissions,
            totalCommissionPercentage,
            maxCommission
        } = this.state

        const {
            _id,
            selectedModel,
            lot_area,
            lot_number,
            block_number,
            selectedProject,
            models =[],
            status,
            client,
            orientation,
            sellerBonus
        } = unit || {}

        return (
            <div className="content">
                <Row>
                    <Col md="12">
                        <Card>
                            <CardHeader className="mb-5">
                                <CardTitle tag="h3">
                                    Unit
                                    <Button
                                        className="float-right"
                                        color="default"
                                        onClick={() => this.goTo('/units')}
                                    >
                                        Back
                                    </Button>
                                </CardTitle>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col sm={12}>
                                        <FormGroup>
                                            <Label>Project <span className="required-start">*</span></Label>
                                            <Async
												clearValue={""}
												value={selectedProject}
												name="selectedProject"
												options={[]}
												loadOptions={this.loadProjects}
												className="basic-multi-select"
												classNamePrefix="select"
												onChange={this.onSpecialSelectChange('selectedProject')}
												placeholder="Projects..."
												isDisabled={true}
											/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col>
                                        <Label>Status</Label>
                                        <Input
											type="select"
											className={status ? '' : 'select__placeholder'}
											name="status"
											onChange={this.onSelectChange('status')}
                                            value={status}
										>
                                            <option value=''>--SELECT--</option>
                                            {unitStatuses.map((status) => {
													return (
														<option key={status} value={status}>{formatUnitStatus(status)}</option>
													)
												})}
                                        </Input>
                                    </Col>
                                </Row>
                                { selectedStatus === 'sold' &&
                                    <Alert color="warning" className="mt-2" fade={false}>
                                        Warning: Please use the "Mark as sold" modal 
                                        instead of setting the status as "sold" directly on this page.
                                    </Alert>
                                }
                                { _id &&
                                    <Row className="mb-3">
                                        <Col>
                                            <FormGroup>
                                            <Label>Client {status === 'reserved' && <span className="required-start">*</span>}</Label>
                                            <Async
                                                clearValue={""}
                                                value={client}
                                                name="client"
                                                options={[]}
                                                loadOptions={this.loadClients}
                                                className="basic-multi-select "
                                                classNamePrefix="select"
                                                onChange={this.onSpecialSelectChange('client')}
                                                placeholder="Client..."
                                                isClearable={true}
                                                isDisabled={status !== 'reserved'}
                                            />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                }
                                { selectedStatus === 'reserved' && !client &&
                                    <Alert color="warning" className="mt-2" fade={false}>
                                        Warning: You must select a client in order to mark this unit as reserved.
                                    </Alert>
								}
                                { status !== 'sold' ? 
                                <Card className="detail-card">
									<CardHeader>
										<h3>Models <i role="button" onClick={this.addModels} className="tim-icons icon-simple-add ml-2 cursor-pointer pull-right" /></h3>
                                        <p>Include all models belonging to this unit.</p>
                                        <p>Changes in price will affect this unit only.</p>
                                    </CardHeader>
                                    <CardBody>
                                        <FormGroup>
                                            {models.map((model, index) => (
                                                <Card className="p-3" key={index} style={{border: "1px solid #2b3553"}}>
                                                    <FormGroup>
                                                        <Label>Model <span className="required-start">*</span></Label>
                                                        <Input
                                                            type="select"
                                                            className="basic-multi-select"
                                                            name="selectedModelType"
                                                            onChange={this.onSpecialSelectChange('selectedModelType', index)}
                                                        >
                                                        <option value=''>{projectModels && projectModels.length > 0 ? 'Select a model' : "This unit doesn't have a model" }</option>
                                                            {projectModels && projectModels.map((selectedModel, count) => {
                                                                return (
                                                                    <option key={selectedModel.name} value={count}>{selectedModel.name}</option>
                                                                )
                                                            })}
                                                        </Input>
                                                    </FormGroup>
                                                    <Row className="my-3">
														<Col sm={5}>
                                                            <Label>Name <span className="required-start">*</span></Label>
															<Input
																type="text"
																name="name"
																placeholder="Name"
																value={model.name}
																onChange={(value) => this.handleModelChange({ target: { name: "name", value: value.target.value, index } })}
                                                                
															/>
														</Col>
														<Col sm={5}>
                                                            <Label>Price <span className="required-start">*</span></Label>
                                                            <CurrencyInput
																name="price"
																placeholder="Price"
																price={model.price || 0}
																onChange={(value) => this.handleModelChange({ target: { name: "price", value, index } })}
															/>
														</Col>
													</Row>
                                                    <Row className="my-3">
                                                        <Col sm={5}>
                                                            <Label>VAT <span className="required-start">*</span></Label>
                                                            <CurrencyInput
																type="number"
																name="vat"
																placeholder="VAT"
																price={model.vat || 0}
																onChange={(value) => this.handleModelChange({ target: { name: "vat", value, index } })}
															/>
														</Col>
														<Col sm={5}>
                                                            <Label>TCP <span className="required-start">*</span></Label>
                                                            <CurrencyInput
																type="number"
																name="tcp"
																placeholder="TCP"
																price={model.tcp || 0}
																onChange={(value) => this.handleModelChange({ target: { name: "tcp", value, index } })}
															/>
														</Col>
													</Row>
                                                    <Row className="my-3">
                                                        <Col sm={3}>
                                                            <FormGroup check className="my-2">
                                                                <Label check>
                                                                    <Input 
                                                                        type="checkbox"
                                                                        name="is_ar"
                                                                        onChange={e => this.onChangeCheckbox(e, index)}
                                                                        checked={model.notAvailable}
                                                                    />
                                                                    <span className="form-check-sign" />
                                                                    This model is not available for this Unit
                                                                </Label>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col className="d-flex align-items-center" sm={2}>
                                                            <i onClick={this.deleteModel(index)} className="tim-icons icon-trash-simple cursor-pointer" />
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            ))}
                                        </FormGroup>
                                    </CardBody>
                                </Card>
                                :
                                <Card className="p-3" style={{border: "1px solid #2b3553"}}>
                                    {
                                        _id &&
                                        <FormGroup>
                                            <Label>Selected Model<span className="required-start">*</span></Label>
                                            <Input
                                                type="select"
                                                className="basic-multi-select p-2"
                                                name="selectedModelType"
                                                onChange={this.onSpecialSelectChange('selectedModelType')}
                                                disabled
                                                value={selectIndex}
                                            >
                                            <option value=''>{projectModels && projectModels.length > 0 ? 'Select a model' : "This unit doesn't have a model" }</option>
                                                {projectModels && projectModels.map((selectedModel, count) => {
                                                    return (
                                                        <option key={selectedModel.name} value={count}>{selectedModel.name}</option>
                                                    )
                                                })}
                                            </Input>
                                        </FormGroup>
                                    }
                                    <Row className="my-3">
                                        <Col sm={12}>
                                            <h4>Selected Model for this Unit</h4>
                                        </Col>
                                        <Col sm={6}>
                                            <Label>Name <span className="required-start">*</span></Label>
                                            <Input
                                                type="text"
                                                name="name"
                                                placeholder="Name"
                                                value={selectedModel?.name || ''}
                                                onChange={(value) => this.onChangeModelField({ target: { name: "name",value: value.target.value }  })}
                                                disabled={!!_id}
                                            />
                                        </Col>
                                        <Col sm={6}>
                                            <Label>Price <span className="required-start">*</span></Label>
                                            <CurrencyInput
                                                name="price"
                                                placeholder="Price"
                                                price={selectedModel?.price}
                                                onChange={(value) => this.onChangeModelField({ target: { name: "price", value } })}
                                                readOnly={!!_id}
                                            />
                                        </Col>
                                    </Row>
                                    {
                                        selectedModel?.discount &&
                                        <>
                                            <Row className="my-3">
                                                <Col sm={6}>
                                                    <Label>Discount </Label>
                                                    <CurrencyInput
                                                        name="discount"
                                                        placeholder="Price"
                                                        price={selectedModel?.discount}
                                                        onChange={(value) => this.onChangeModelField({ target: { name: "discount", value } })}
                                                        readOnly={!!_id}
                                                    />
                                                </Col>
                                                <Col sm={6}>
                                                    <Label>Net Price </Label>
                                                    <CurrencyInput
                                                        price={selectedModel?.price - selectedModel?.discount}
                                                        readOnly={!!_id}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12}>
                                                    <Label>Discount Details</Label>
                                                    <Input 
                                                        type='textarea'
                                                        className='p-2'
                                                        value={selectedModel?.discount_details}
                                                        disabled
                                                    />
                                                </Col>
                                            </Row>
                                        </>  
                                    }
                                    <Row className="my-3">
                                        <Col sm={6}>
                                            <Label>VAT <span className="required-start">*</span></Label>
                                            <CurrencyInput
                                                name="vat"
                                                placeholder="VAT"
                                                price={selectedModel?.vat || 0}
                                                onChange={(value) => this.onChangeModelField({ target: { name: "vat", value } })}
                                                readOnly={!!_id}
                                            />
                                        </Col>
                                        <Col sm={6}>
                                            <Label>TCP <span className="required-start">*</span></Label>
                                            <CurrencyInput
                                                name="tcp"
                                                placeholder="TCP"
                                                price={selectedModel?.tcp || 0}
                                                onChange={(value) => this.onChangeModelField({ target: { name: "tcp", value } })}
                                                readOnly={!!_id}
                                            />
                                        </Col>
                                    </Row>
                                </Card>
                                }
                                <Row>
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label>Block Number <span className="required-start">*</span></Label>
                                            <Input
                                                type="text"
                                                name="block_number"
                                                value={block_number || ''}
                                                onChange={this.onChangeField}
                                                placeholder="Block Number"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label>Lot Number  <span className="required-start">*</span></Label>
                                            <Input
                                                type="number"
                                                name="lot_number"
                                                value={lot_number}
                                                onChange={this.onChangeField}
                                                placeholder="Lot Number"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label>Lot Area</Label>
                                            <Input
                                                type="number"
                                                name="lot_area"
                                                value={lot_area}
                                                onChange={this.onChangeField}
                                                placeholder="Lot Area"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label>Orientation</Label>
                                            <Input
                                                type="select"
                                                className={orientation ? '' : 'select__placeholder'}
                                                name="orientation"
                                                onChange={this.onSelectChange('orientation')}
                                                value={orientation}
                                            >
                                                <option value=''>--SELECT--</option>
                                                {unitOrietantion.map((status) => {
                                                        return (
                                                            <option key={status} value={status}>{formatUnitOrietation(status)}</option>
                                                        )
                                                    })}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>  
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label>Seller Bonus</Label>
                                            <Input
                                                name="sellerBonus"
                                                value={sellerBonus}
                                                onChange={this.onChangeField}
                                                placeholder="Seller Bonus"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                
                                {/* Commission Section */}
                                <Card className="detail-card">
                                    <CardHeader>
                                        <h3>Commissions <i role="button" onClick={this.addCommission} className="tim-icons icon-simple-add ml-2 cursor-pointer pull-right" /></h3>
                                        <p>Configure commission recipients for this unit.</p>
                                        <p>Total commission: <strong>{totalCommissionPercentage.toFixed(2)}%</strong> (Maximum {maxCommission}%)</p>
                                        {totalCommissionPercentage > maxCommission && (
                                            <Alert color="danger" className="mt-2" fade={false}>
                                                Total commission percentage cannot exceed {maxCommission}%
                                            </Alert>
                                        )}
                                    </CardHeader>
                                    <CardBody>
                                        <FormGroup>
                                            {commissions.map((commission, index) => (
                                                <Card className="p-3" key={index} style={{border: "1px solid #2b3553"}}>
                                                    <Row className="my-3">
                                                        <Col sm={4}>
                                                            <Label>Recipient Type <span className="required-start">*</span></Label>
                                                            <Input
                                                                type="select"
                                                                className="basic-multi-select"
                                                                name="recipientType"
                                                                value={commission.recipientType}
                                                                onChange={(e) => this.onCommissionSelectChange('recipientType', index)(e)}
                                                            >
                                                                <option value=''>Select Type</option>
                                                                <option value='broker'>Broker</option>
                                                                <option value='seller'>Seller</option>
                                                            </Input>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Label>Recipient <span className="required-start">*</span></Label>
                                                            {commission.recipientType === 'broker' ? (
                                                                <Async
                                                                    clearValue={""}
                                                                    value={commission.recipientId ? { value: commission.recipientId, label: commission.recipientName || 'Selected Broker' } : null}
                                                                    name="recipientId"
                                                                    options={[]}
                                                                    loadOptions={this.loadBrokers}
                                                                    className="basic-multi-select"
                                                                    classNamePrefix="select"
                                                                    onChange={this.onCommissionSelectChange('recipientId', index)}
                                                                    placeholder="Select Broker..."
                                                                    isClearable={true}
                                                                />
                                                            ) : commission.recipientType === 'seller' ? (
                                                                <Async
                                                                    clearValue={""}
                                                                    value={commission.recipientId ? { value: commission.recipientId, label: commission.recipientName || 'Selected Seller' } : null}
                                                                    name="recipientId"
                                                                    options={[]}
                                                                    loadOptions={this.loadSellers}
                                                                    className="basic-multi-select"
                                                                    classNamePrefix="select"
                                                                    onChange={this.onCommissionSelectChange('recipientId', index)}
                                                                    placeholder="Select Seller..."
                                                                    isClearable={true}
                                                                />
                                                            ) : (
                                                                <Input
                                                                    type="text"
                                                                    placeholder="Select recipient type first"
                                                                    disabled
                                                                />
                                                            )}
                                                        </Col>
                                                        <Col sm={3}>
                                                            <Label>Percentage <span className="required-start">*</span></Label>
                                                            <Input
                                                                type="number"
                                                                name="percentage"
                                                                placeholder="0.00"
                                                                value={commission.percentage}
                                                                onChange={(e) => this.handleCommissionChange({ target: { name: "percentage", value: e.target.value, index } })}
                                                                min="0"
                                                                max={maxCommission}
                                                                step="0.01"
                                                            />
                                                        </Col>
                                                        <Col className="d-flex align-items-center" sm={1}>
                                                            <i onClick={this.deleteCommission(index)} className="tim-icons icon-trash-simple cursor-pointer" />
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            ))}
                                            {(!commissions || commissions.length === 0) && (
                                                <p className="text-muted">No commissions configured. Click the + icon to add a commission.</p>
                                            )}
                                        </FormGroup>
                                    </CardBody>
                                </Card>
      
                                { error && 
                                    <Alert color="danger" className="mt-2" fade={false}>
                                        <span>{error}</span>
                                    </Alert> 
                                }
                            </CardBody>


                            <Col>
                                <Button color="primary" block={false} className="mb-4" onClick={this.save} disabled={saving}>
                                    {saving
                                        ? "Saving..."
                                        : _id
                                            ? "Save Changes"
                                            : "Save Unit"
                                    }
                                </Button>
                            </Col>

                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default UnitForm